import { ALL_STATUS_NAMES } from '@/utils/status-names-factory'

export const applyStatusNames = ({ confidenceLevelCustomNames = {} } = {}) => {
  ALL_STATUS_NAMES.bulkUpdateStatusTranslations(confidenceLevelCustomNames)
}
